module.exports = __webpack_public_path__ + "static/img/son3_active.e9674f4e.png";